module.exports = __webpack_public_path__ + "img/isass.922636e6.png";